<script>
import { Doughnut } from 'vue-chartjs'
import Tools from '@/tools/tools.js'

const brandCredito = '#4dbd74' // mesma cor do crédito
const brandDebito  = '#f86c6b' // mesma cor do débito
const convertHex = (hex, opacity) => {
  hex = hex.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return `rgba(${r},${g},${b},${opacity/100})`
}

const fmtBRL = v =>
  Number(v || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

// tooltip: mostra valor e % do total
const tooltipLabel = (ti, data) => {
  const valor = data.datasets[ti.datasetIndex].data[ti.index] || 0
  const total = data.datasets[ti.datasetIndex].data.reduce((a, b) => a + b, 0) || 1
  const pct = (valor / total) * 100
  const label = data.labels[ti.index] || ''
  return `${label}: ${fmtBRL(valor)} (${pct.toFixed(1)}%)`
}

export default {
  extends: Doughnut,
  name: 'GraficoPizzaLancamentosCaixa',
  props: {
    dt1: { type: String, default: '' },
    dt2: { type: String, default: '' },
    incAtualizar: { type: Number, default: 0 }
  },
  data () {
    return {
      busy: false,
      tipos: ['Crédito', 'Débito'], // ordem fixa [CREDITO, DEBITO]
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 55, // “rosquinha”; troque para 0 se quiser pizza cheia
        animation: { duration: 0 },
        legend: { display: true, position: 'bottom' },
        tooltips: {
          callbacks: { label: tooltipLabel }
        },
        plugins: { zoom: { pan: { enabled: false }, zoom: { enabled: false } } }
      }
    }
  },
  methods: {
    abrirModalTipo (tipo) {
      // emite para o pai; use @abrir-modal-tipo no pai
      this.$emit('abrir-modal-tipo', { tipo })
    },

    renderPizza (creditoTotal, debitoTotal) {
      const labels = ['Crédito', 'Débito']
      const dataVals = [creditoTotal, debitoTotal]

      const data = {
        labels,
        datasets: [{
          data: dataVals,
          backgroundColor: [convertHex('#4dbd74', 55), convertHex('#f86c6b', 55)],
          borderColor: ['#4dbd74', '#f86c6b'],
          borderWidth: 2
        }]
      }

      const options = {
        ...this.chartOptions,
        // <<< LEGENDA COM TOTAIS
        legend: {
          ...this.chartOptions.legend,
          labels: {
            ...(this.chartOptions.legend?.labels || {}),
            generateLabels: (chart) => {
              const ds = chart.data.datasets[0]
              const meta = chart.getDatasetMeta(0)
              return chart.data.labels.map((label, i) => ({
                // texto exibido na legenda
                text: `${label} — ${fmtBRL(ds.data[i])}`,
                // estilos do marcador
                fillStyle: Array.isArray(ds.backgroundColor) ? ds.backgroundColor[i] : ds.backgroundColor,
                strokeStyle: Array.isArray(ds.borderColor) ? ds.borderColor[i] : ds.borderColor,
                lineWidth: ds.borderWidth,
                // necessário pra toggle funcionar
                hidden: meta.data[i] ? meta.data[i].hidden : false,
                index: i,
                datasetIndex: 0
              }))
            }
          }
        },
        // clique na fatia -> abrir modal por tipo
        onClick: (evt) => {
          if (!this._chart) return
          let elems = []
          if (typeof this._chart.getElementsAtEventForMode === 'function') {
            elems = this._chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, false)
          } else {
            elems = this._chart.getElementAtEvent(evt) || []
          }
          if (elems && elems.length) {
            const idx = elems[0]._index
            const label = data.labels[idx]
            this.abrirModalTipo(label.toUpperCase().includes('DÉB') ? 'DEBITO' : 'CREDITO')
          }
        }
      }

      if (this._chart) this._chart.destroy()
      this.$nextTick(() => this.renderChart(data, options))
    },

    async getDados () {
      // avisa o pai para ligar o overlay
      this.$emit('busy', true)
      try {
        this.busy = true
        const { data: payload } = await this.$http.get('/api/protected/caixa/item/listar', {
          params: { dt1: this.dt1, dt2: this.dt2 }
        })

        const itens = Array.isArray(payload) ? payload : (payload?.data || [])

        // soma total por tipo
        let creditoTotal = 0
        let debitoTotal = 0
        for (const it of itens) {
          const v = Number(it.VL_MOV || 0)
          if (it.TIPO === 'CREDITO') creditoTotal += v
          else if (it.TIPO === 'DEBITO') debitoTotal += v
        }

        this.renderPizza(creditoTotal, debitoTotal)
      } catch (e) {
        Tools.exibirMensagem(this.$store, 'Não foi possível buscar os dados', 'danger', e)
      } finally {
        this.busy = false
        this.$emit('busy', false)
      }
    }
  },
  watch: {
    incAtualizar: 'getDados',
    dt1: 'getDados',
    dt2: 'getDados'
  },
  async created () {
    await this.getDados()
  },
  beforeDestroy () {
    if (this._chart) this._chart.destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/GraficoPizzaLancamentosCaixa.vue